"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestIpDrugEntryCancelSchema = void 0;
/**
 * IP DRUG BILL CANCEL REQUEST - a ward / pharmacy clerk asks for a drug bill entered on an IP bill to be CANCELLED; a verifier and an approver
 * decide it (owner, 2026-10-17: "under IP drug entries page need option for cancel after View/Refund. when user select the cancel it should ask
 * reason and send for approval. it goes to Verify and approval process").
 *
 * The body is only WHICH entry and WHY. The reason is what the verifier and approver read, so it is required. Nothing on the entry or the IP
 * bill changes until approval.
 */
const zod_1 = require("zod");
exports.requestIpDrugEntryCancelSchema = zod_1.z.object({
    entryId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().trim().min(5, 'A reason is required (at least 5 characters)').max(500),
});
//# sourceMappingURL=financial-ip-drug-cancel.request.js.map